export default __webpack_public_path__ + "e270312e768e2ff5b14196fe98bc26f9.png";